import React from 'react'

const QA = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Garantia de Qualidade (QA)</h3>
    
            <div className="skills__box">

                {/* grupo 01 */}
                <div className="skills__group">
                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
                        
                        <div>
                            <h3 className="skills__name">Postman</h3>
                            <span className="skills__level">Avançado</span>
                        </div>
                    </div>
    
                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
    
                        <div>
                            <h3 className="skills__name">JMeter</h3>
                            <span className="skills__level">Avançado</span>
                        </div>
                    </div>
    
                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
    
                        <div>
                            <h3 className="skills__name">K6</h3>
                            <span className="skills__level">Avançado</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
    
                        <div>
                            <h3 className="skills__name">JUnit</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                </div>
    
                {/* grupo 02 */}
                <div className="skills__group">
                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
    
                        <div>
                            <h3 className="skills__name">GitLab </h3>
                            <span className="skills__level">Avançado</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
    
                        <div>
                            <h3 className="skills__name">Docker</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
    
                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
    
                        <div>
                            <h3 className="skills__name">JIRA</h3>
                            <span className="skills__level">Avançado</span>
                        </div>
                    </div>
    
                    <div className="skills__data">
                        <i class='bx bx-badge-check'></i>
    
                        <div>
                            <h3 className="skills__name">Jenkins</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      )
}
export default QA;